export default "__VITE_ASSET__Cz5T7bTn__"